import { PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { styles, Text } from '@frontend/design-system';
import { PROVIDER_COLUMN_GAP, PROVIDER_COLUMN_MIN_WIDTH, SCROLLABLE_BUTTON_WIDTH } from '../constants';
import { useCalendarView } from '../providers';

type SlidingOfficeName = {
  name: string;
  maxWidth: number;
};

// TODO: use TruncatedText component instead of styles.truncate
const SlidingOfficeName = ({ name, maxWidth }: SlidingOfficeName) => (
  <div
    css={css`
      display: flex;
      align-items: center;
      gap: ${theme.spacing(0.5)};
      position: sticky;
      left: 116px;
      right: 56px;
      margin: 0 ${theme.spacing(2)};
    `}
  >
    <Icon name='location' color='subdued' />
    <Text css={[styles.truncate, { maxWidth }]} textAlign='center' size='medium' weight='bold' color='subdued'>
      {name}
    </Text>
  </div>
);

type MultiOfficeSectionWrapperProps = {
  officeName: string;
  providerCount: number;
  showLocationHeader: boolean;
};

export const MultiOfficeSectionWrapper = ({
  children,
  officeName,
  providerCount,
  showLocationHeader,
}: PropsWithChildren<MultiOfficeSectionWrapperProps>) => {
  const { containerState } = useCalendarView(['containerState']);

  return (
    <div
      css={css`
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: ${theme.spacing(1, 0)};
      `}
    >
      {showLocationHeader && (
        <div css={{ height: 32, width: '100%' }}>
          <div
            css={css`
              display: flex;
              justify-content: center;
              position: sticky;
              max-width: ${containerState?.clientWidth - SCROLLABLE_BUTTON_WIDTH}px;
              background: ${theme.colors.neutral5};
              border-radius: ${theme.borderRadius.medium};
              left: 0;
              height: 100%;
            `}
          >
            <SlidingOfficeName name={officeName} maxWidth={(providerCount + 1) * PROVIDER_COLUMN_MIN_WIDTH - 60} />
          </div>
        </div>
      )}
      <section
        css={css`
          display: flex;
          gap: ${PROVIDER_COLUMN_GAP}px;
          justify-content: space-around;
        `}
      >
        {children}
      </section>
    </div>
  );
};
